import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const RemoveTrailingSlash = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const { pathname, search, hash } = location;

        // Remove trailing slash from pathname (but not if it's the root "/")
        if (pathname.length > 1 && pathname.endsWith("/")) {
            const newPath = pathname.slice(0, -1);
            navigate(`${newPath}${search}${hash}`, { replace: true });
        }
    }, [location, navigate]);

    return null;
};

export default RemoveTrailingSlash;
